<div class="flex justify-between items-center flex-wrap gap-1 mb-1">
  <nz-radio-group [(ngModel)]="quickFilter" (ngModelChange)="filterData()" nzButtonStyle="outline">
    <label nz-radio-button nzValue="all" class="font-semibold radio-button-primary">
      <i nz-icon nzType="unordered-list" nzTheme="outline" class="mr-2"></i>
      All {{counts.total_count}}
    </label>
    <label nz-radio-button nzValue="active" class="font-semibold radio-button-success">
      <i nz-icon nzType="hezky:Gateway" nzTheme="outline" class="mr-2"></i>
      Active {{counts.active_count}}
    </label>
    <label nz-radio-button nzValue="inActive" class="font-semibold radio-button-warning">
      <span class="text-[9px] text-[#B7B7B7]">x</span>
      <i class="mr-2" style="font-size: 14px !important;color: rgb(176, 180, 180);" nz-icon
        [nzType]="'hezky:Signal'"></i>
      Inactive {{counts.inactive_count}}
    </label>
  </nz-radio-group>
  <nz-page-header-extra>
    <nz-space>
      <nz-input-group class="mr-1" [nzPrefix]="searchIcon">
        <input nz-input class="w-full" type="search" [(ngModel)]="searchText" placeholder="Search here..."
          (ngModelChange)="getSearchDetails(searchText)">
      </nz-input-group>
      <ng-template #searchIcon>
        <span nz-icon nzType="search" aria-hidden="true"></span>
      </ng-template>
      <button nz-button class="mr-1" nzType="default" type="button" [nzTooltipColor]="'#fff'" nz-tooltip
        nzTooltipTitle="Refresh" [nzShape]="'circle'" (click)="refreshHandler()">
        <i nz-icon nzType="reload"></i>
      </button>
      <button nz-button class="mr-1" [nzType]="'primary'" nzSize="default" (click)="showModal('excel')"><i nz-icon
          nzType="plus"></i>Add Excel</button>
      <button nz-button class="mr-1" [nzType]="'primary'" nzSize="default" (click)="showModal('user')"><i nz-icon
          nzType="plus"></i>Add User</button>
    </nz-space>
  </nz-page-header-extra>
</div>

<nz-table #usersTable nzShowSizeChanger [nzLoading]="isConfirmLoading" [nzScroll]="{ x: '1024px', y: '35dvh' }"
  [nzSize]="'small'" [nzPaginationType]="'small'" [nzShowTotal]="totalTemplate" [nzData]="filteredUserList$">
  <thead>
    <tr>
      <th *ngFor="let column of listOfColumns" nzEllipsis="...">{{column.name}}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of usersTable.data; let i = index; trackBy: commonService.trackByFn">
      <td nzEllipsis="...">{{user.user_id}}</td>
      <td nzEllipsis="...">{{user.first_name}}</td>
      <td nzEllipsis="...">{{user.last_name}}</td>
      <td nzEllipsis="...">{{user.email}}</td>
      <td nzEllipsis="...">{{user.contact}}</td>
      <td nzEllipsis="...">{{user.role_name}}</td>
      <td>
        <button nzType="default" [ngClass]="{
                        'text-green-600': user?.is_active,
                        'text-red-600': !user?.is_active }">
          {{ user?.is_active ? 'Active' : 'In-Active' }}
        </button>
      </td>
      <td>
        <div class="flex items-center space-x-2">
          <!-- Edit User -->
          <button nz-button nzType="link" nzSize="small" (click)="editUser(user)" nz-tooltip
            nzTooltipTitle="Modify User" [nzTooltipColor]="'#fff'">
            <i nz-icon nzType="edit" nzTheme="outline" class="text-primary"></i>
          </button>

          <!-- Activate/Deactivate User with Confirmation -->
          <a nz-popconfirm
            [nzPopconfirmTitle]="user?.is_active ? 'Are you sure you want to deactivate this user?' : 'Are you sure you want to activate this user?'"
            nzPopconfirmPlacement="top" (nzOnConfirm)="toggleUserStatus(user.user_id, !user?.is_active)" nzOkText="Yes"
            nzCancelText="No">
            <button nz-button nzType="link" nzSize="small" nz-tooltip
              [nzTooltipTitle]="user?.is_active ? 'Deactivate User' : 'Activate User'" [nzTooltipColor]="'#fff'">
              <i nz-icon [nzType]="user?.is_active ? 'stop' : 'play-circle'" nzTheme="outline"
                [ngClass]="{'text-danger': user?.is_active, 'text-success': !user?.is_active}"></i>
            </button>
          </a>

          <!-- Manage Location Access -->
          <button nz-button nzType="link" nzSize="small" (click)="modifyUserLocation(user)" nz-tooltip
            nzTooltipTitle="Manage Location Access" [nzTooltipColor]="'#fff'">
            <i nz-icon nzType="environment" nzTheme="outline" class="text-warning"></i>
          </button>

          <!-- Modify Roles -->
          <button nz-button nzType="link" nzSize="small" (click)="modifyUserRoles(user)" nz-tooltip
            nzTooltipTitle="Modify Roles" [nzTooltipColor]="'#fff'">
            <i nz-icon nzType="user-switch" nzTheme="outline" class="text-info"></i>
          </button>

          <!-- Reset Password with nz-popconfirm -->
          <a nz-popconfirm nzPopconfirmTitle="Are you sure you want to reset the password for this user?"
            nzPopconfirmPlacement="top" (nzOnConfirm)="resetUserPassword(user.user_id)" nzOkText="Yes"
            nzCancelText="No">
            <button nz-button nzType="link" nzSize="small" nz-tooltip nzTooltipTitle="Reset Password"
              [nzTooltipColor]="'#fff'">
              <i nz-icon nzType="lock" nzTheme="outline" class="text-green-600"></i>
            </button>
          </a>
        </div>
      </td>
    </tr>
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isExcelModalVisible" [nzTitle]="modalTitle" (nzOnCancel)="handleCancel('excel')" sh>
  <ng-template #modalTitle>
    <div class="flex justify-between items-center">
      <span>Add Excel</span>
      <a *ngIf="excelErrLink" (click)="downloadLogFile()"
        class="text-blue-600 pt-10 font-bold cursor-pointer hover:underline">
        <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
        Download Log
      </a>
    </div>
  </ng-template>

  <ng-template #excelContent>
    <ng-container>
      <div *ngIf="excelErr && !isSuccessMessage" class="mb-4 p-3 bg-red-50 text-red-700 border border-red-200 rounded">
        <strong>Error:</strong> {{ excelErr }}
      </div>

      <!-- Success Message -->
      <div *ngIf="excelErr && isSuccessMessage"
        class="mb-4 p-3 bg-green-50 text-green-700 border border-green-200 rounded">
        <strong>Success:</strong> {{ excelErr }}
      </div>
      <ng-container>
        <div *ngIf="!excelErrLink" class="mb-3 text-center flex justify-end">
          <a class="cursor-pointer hover:underline text-blue-600 font-bold" nz-popconfirm
            (nzOnConfirm)="downloadTemplate()" nzPopconfirmTitle="Are you sure to download this template file?"
            nzPopconfirmPlacement="bottom">
            <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
            Download Template
          </a>
        </div>
        <div class="upload-container">
          <label for="excelFile" class="custom-file-upload">
            <span> <i nz-icon nzType="upload" nzTheme="outline" class="text-primary text-[30px]"></i></span>
            <input type="file" id="excelFile" (change)="onFileChange($event)" accept=".xls,.xlsx,.csv">
            <p class="ant-upload-text">Click or drag file to this area to upload</p>
            <p class="ant-upload-hint">File headers should match, and all fields must have appropriate data.</p>
          </label>

        </div>
        <div class="uploaded-files" *ngIf="fileList.length > 0">
          <div *ngFor="let file of fileList; let i = index"
            class="uploaded-file flex items-center justify-between mb-2">
            <i nz-icon [nzType]="file.name.toLowerCase().endsWith('.xlsx') ? 'file-excel' : 'file-excel'"
              nzTheme="twotone" class="mr-2"></i>
            <span class="filename flex-1">{{ file?.name }}</span>
            <span class="filesize text-sm text-gray-600">
              ({{ (file.size / 1024 / 1024).toFixed(2) }} MB)
            </span>
            <button type="button" nzType="link" (click)="removeFile(i)">
              <i nz-icon nzType="delete"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #excelFooter>
    <div class="flex justify-end">
      <button nz-button nzType="default" (click)="handleCancel('excel')">Cancel</button>
      <button nz-button nzType="primary" (click)="onExcelSubmit()" [nzLoading]="isConfirmLoading">Submit</button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="excelContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="excelFooter"></ng-container>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isUserModalVisible" [nzTitle]="isEditMode ? 'Edit User' : 'Add New User'"
  (nzOnCancel)="handleCancel('user')" [nzWidth]="550">

  <ng-template #userContent>
    <form nz-form [formGroup]="form" nzLayout="vertical">
      <div class="grid grid-cols-2 gap-x-4">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="firstName">First Name</nz-form-label>
          <nz-form-control [nzErrorTip]="'First Name is required'">
            <input nz-input formControlName="firstName" placeholder="Enter First Name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired nzFor="lastName">Last Name</nz-form-label>
          <nz-form-control [nzErrorTip]="'Last Name is required'">
            <input nz-input formControlName="lastName" placeholder="Enter Last Name" />
          </nz-form-control>
        </nz-form-item>
      </div>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="email">Email</nz-form-label>
        <nz-form-control [nzErrorTip]="'Email is required'">
          <input nz-input formControlName="email" type="email" placeholder="Enter Email" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="contact">Contact Number</nz-form-label>
        <nz-form-control [nzErrorTip]="contactErrorTpl">
          <nz-input-group [nzAddOnBefore]="countryCodeSelect" class="w-full">
            <input nz-input formControlName="contact" type="tel" placeholder="Enter Contact Number" maxlength="10" />
          </nz-input-group>
          <ng-template #countryCodeSelect>
            <nz-select formControlName="countryCode" nzShowSearch class="w-[120px]">
              <nz-option *ngFor="let country of countryCodes" [nzValue]="country.code"
                [nzLabel]="country.code + ' ' + country.country">
              </nz-option>
            </nz-select>
          </ng-template>
        </nz-form-control>
        <ng-template #contactErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            Contact Number is required
          </ng-container>
          <ng-container *ngIf="control.hasError('pattern')">
            Please enter exactly 10 digits
          </ng-container>
        </ng-template>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="role">Role</nz-form-label>
        <nz-form-control [nzErrorTip]="'Role is required'">
          <nz-select formControlName="role" nzPlaceHolder="Select Role" nzShowSearch [nzAllowClear]="true"
            class="w-full">
            <nz-option-group nzLabel="Default Roles">
              <nz-option *ngFor="let role of defaultUserRoles" [nzValue]="role.role_id * 1" [nzLabel]="role.role_name">
              </nz-option>
            </nz-option-group>
            <nz-option-group nzLabel="Customer Roles">
              <nz-option *ngFor="let role of customerUserRoles" [nzValue]="role.role_id * 1" [nzLabel]="role.role_name">
              </nz-option>
            </nz-option-group>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired>Location Permissions</nz-form-label>
        <nz-form-control [nzErrorTip]="'At least one location is required'">
          <nz-spin [nzSpinning]="isLoadingFormLocations">
            <nz-select formControlName="locationPerms" nzMode="multiple" nzPlaceHolder="Select Locations" nzShowSearch
              [nzAllowClear]="true" class="w-full">
              <nz-option *ngFor="let location of addFormLocations" [nzValue]="location.value"
                [nzLabel]="location.label">
              </nz-option>
            </nz-select>
            <nz-empty *ngIf="addFormLocations.length === 0 && !isLoadingFormLocations"
              nzDescription="No locations found" [nzNotFoundImage]="'simple'"></nz-empty>
          </nz-spin>
          <small class="text-gray-500 mt-1 block text-xs">Select locations this user should have access to</small>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Application Access</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="applicationId" nzMode="multiple" nzPlaceHolder="Select Applications" nzShowSearch
            [nzAllowClear]="true" class="w-full">
            <nz-option *ngFor="let app of applications" [nzValue]="app.value" [nzLabel]="app.label">
              <span class="flex items-center gap-1">
                <i *ngIf="app.icon" nz-icon [nzType]="app.icon" class="text-primary"></i>
                {{ app.label }}
              </span>
            </nz-option>
          </nz-select>
          <nz-empty *ngIf="applications.length === 0" nzDescription="No applications found"
            [nzNotFoundImage]="'simple'"></nz-empty>
          <small class="text-gray-500 mt-1 block text-xs">Select applications this user can access</small>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-template>

  <ng-template #userFooter>
    <div class="flex justify-end">
      <button nz-button nzType="default" (click)="handleCancel('user')">Cancel</button>
      <button nz-button nzType="primary" (click)="onSubmit()" [nzLoading]="isConfirmLoading">
        {{ isEditMode ? 'Update' : 'Submit' }}
      </button>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="userContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="userFooter"></ng-container>
  </ng-container>
</nz-modal>

<ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>

<!-- Location Access Modal -->
<nz-modal [(nzVisible)]="isLocationModalVisible" [nzTitle]="'Manage Location Access'" [nzWidth]="700"
  [nzOkText]="'Save'" [nzCancelText]="'Cancel'" [nzOkLoading]="isConfirmLoading" (nzOnCancel)="handleLocationCancel()"
  (nzOnOk)="saveUserLocations()">
  <ng-container *nzModalContent>
    <div class="mb-4 p-3 bg-blue-50 border-l-4 border-blue-500 rounded-md" *ngIf="currentUserForLocation">
      <h3 class="text-lg font-medium flex items-center">
        <i nz-icon nzType="user" nzTheme="outline" class="mr-2 text-blue-500"></i>
        {{ currentUserForLocation.first_name }} {{ currentUserForLocation.last_name }}
      </h3>
      <p class="text-sm text-gray-600 ml-6">
        Select locations this user should have access to
      </p>
    </div>

    <div class="location-tree-container">
      <nz-spin [nzSpinning]="isLoadingLocations">
        <div
          class="location-tree-wrapper p-4 border border-gray-200 rounded-md bg-white shadow-sm max-h-[400px] overflow-auto">
          <nz-empty *ngIf="!userLocations || userLocations.length === 0 && !isLoadingLocations"
            nzDescription="No locations found"></nz-empty>

          <nz-tree *ngIf="userLocations && userLocations.length > 0" [nzData]="userLocations" nzCheckable
            [nzShowLine]="false" [nzShowIcon]="false" [nzExpandAll]="true" [nzCheckedKeys]="selectedLocations"
            [nzTreeTemplate]="nzTreeNodeTemplate" (nzClick)="handleNodeClick($event)"
            (nzCheckBoxChange)="onLocationSelectionChange($event.checkedKeys)">
          </nz-tree>

          <ng-template #nzTreeNodeTemplate let-node>
            <div class="flex items-center py-1 hover:bg-gray-50">
              <span class="folder-name">{{ node.title }}</span>
              <!-- <span *ngIf="node.isLeaf"
                class="ml-2 px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded-full">Location</span>
              <span *ngIf="!node.isLeaf"
                class="ml-2 px-2 py-0.5 bg-blue-100 text-blue-600 text-xs rounded-full">Group</span> -->
            </div>
          </ng-template>
        </div>
      </nz-spin>
    </div>
  </ng-container>
</nz-modal>

<!-- User Roles Modal -->
<nz-modal [(nzVisible)]="isRolesModalVisible" [nzTitle]="'Manage User Roles'" [nzWidth]="500" [nzOkText]="'Save'"
  [nzCancelText]="'Cancel'" [nzOkLoading]="isConfirmLoading" (nzOnCancel)="handleRolesCancel()"
  (nzOnOk)="saveUserRoles()">
  <ng-container *nzModalContent>
    <div class="mb-4" *ngIf="currentUserForRole">
      <h3 class="text-lg font-medium">
        User: {{ currentUserForRole.first_name }} {{ currentUserForRole.last_name }}
      </h3>
      <p class="text-sm text-gray-500">
        Assign roles to this user
      </p>
    </div>

    <div class="roles-container">
      <nz-spin [nzSpinning]="isLoadingRoles">
        <div class="roles-wrapper p-3 border border-gray-200 rounded-md">
          <nz-empty *ngIf="!userRoles || userRoles.length === 0 && !isLoadingRoles"
            nzDescription="No roles found"></nz-empty>

          <div *ngIf="userRoles && userRoles.length > 0" class="w-full">
            <nz-form-item>
              <nz-form-label class="text-left">Select Role</nz-form-label>
              <nz-form-control>
                <nz-select class="w-full" [(ngModel)]="selectedRole" nzPlaceHolder="Select a role" [nzShowSearch]="true"
                  [nzAllowClear]="false">
                  <nz-option-group nzLabel="Default Roles">
                    <nz-option *ngFor="let role of defaultUserRoles" [nzValue]="role.role_id * 1"
                      [nzLabel]="role.role_name">
                    </nz-option>
                  </nz-option-group>
                  <nz-option-group nzLabel="Customer Roles">
                    <nz-option *ngFor="let role of customerUserRoles" [nzValue]="role.role_id * 1"
                      [nzLabel]="role.role_name">
                    </nz-option>
                  </nz-option-group>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </nz-spin>
    </div>
  </ng-container>
</nz-modal>